import { Check } from "lucide-react";

export default function FeatureChecklistItem({ children }) {
  return (
    <li className="flex items-start gap-2.5">
      <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-600">
        <Check className="h-3 w-3" strokeWidth={3} />
      </span>
      <span className="text-sm text-neutral-700">{children}</span>
    </li>
  );
}
